import axios from "axios";
import {API_URL} from "@env";

export const getConsultants = (mode='', status) => {
    return axios.get(API_URL + `/consultant/${mode}?status=${status}`);
}

export const getTodayConsultants = (mode='') => {
    return axios.get(API_URL + `/today-consultant/${mode}`);
}